import React, { useState, useCallback } from "react";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import DateFilter from "@/components/dashboard/filter/DateFilter";
import LayerIndicator from "@/components/dashboard/indicator/LayerIndicator";
import RouteDate from "@/components/dashboard/misc/RouteDate";
import Flow from "@/components/dashboard/misc/Flow";
import ArchStep from "@/components/dashboard/misc/ArchStep";
import IceSituation from "@/components/dashboard/misc/IceSituation";
import Temperature from "@/components/dashboard/misc/Temperature";
import StepOperation from "@/components/dashboard/misc/StepOperation";
import CenterSelector from "@/components/dashboard/misc/CenterSelector";
import Order from "@/components/dashboard/misc/Order";
import NavigatorForm from "@/components/dashboard/misc/NavigatorForm";
import { panelNames } from "@/util";
import "@/components/dashboard/DashboardPanel.less";

const DashboardPanel = ({ type }) => {
  const { t } = useTranslation();
  const [maxium, setMaxium] = useState(false);
  const toggleSize = useCallback(() => {
    setMaxium(!maxium);
  }, [setMaxium, maxium]);
  let body;
  switch (type) {
    case "timeline": {
      body = <DateFilter maxium={maxium} />;
      break;
    }
    case "indicator": {
      body = <LayerIndicator maxium={maxium} />;
      break;
    }
    case "flow": {
      body = <Flow maxium={maxium} />;
      break;
    }
    case "archStep": {
      body = <ArchStep maxium={maxium} />;
      break;
    }
    case "routeDate": {
      body = <RouteDate maxium={maxium} />;
      break;
    }
    case "ice": {
      body = <IceSituation maxium={maxium} />;
      break;
    }
    case "weather": {
      body = <Temperature maxium={maxium} />;
      break;
    }
    case "center": {
      body = <CenterSelector maxium={maxium} />;
      break;
    }
    case "step": {
      body = <StepOperation maxium={maxium} />;
      break;
    }
    case "order": {
      body = <Order maxium={maxium} />;
      break;
    }
    case "form": {
      body = <NavigatorForm maxium={maxium} />;
      break;
    }
    default:
      body = null;
  }
  if (maxium) {
    return (
      <div className="dashboard-panel">
        <div className="dashboard-panel-modal">
          <div className="title">
            {panelNames[type]}
            <span className="toolbar">
              {maxium ? (
                <FullscreenExitOutlined onClick={toggleSize} />
              ) : (
                <FullscreenOutlined onClick={toggleSize} />
              )}
            </span>
          </div>
          <div className="body">{body}</div>
        </div>
      </div>
    );
  }
  return (
    <div className="dashboard-panel">
      {type !== "timeline" && (
        <div className="title">
          {t(`switcher.${type}`)}
          <span className="toolbar">
            <FullscreenOutlined onClick={toggleSize} />
          </span>
        </div>
      )}
      <div className="body">{body}</div>
    </div>
  );
};

export default DashboardPanel;
